import { useQuery } from '@tanstack/react-query';

import {
  getClaimsAsPartyById,
  type GetClaimsAsPartyByIdResponse,
} from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from './../queryKeys';

export default function useClaims(
  partyId: string,
  claimId: string,
  options?: QueryOptions<GetClaimsAsPartyByIdResponse>,
) {
  return useQuery({
    queryKey: queryKeys.byId(partyId, claimId),
    queryFn: () =>
      getClaimsAsPartyById(
        {
          path: { party_id: partyId, claim_id: claimId },
        },
        wgApi,
      ),
    ...options,
  });
}
